import React from 'react';
import PropTypes from 'prop-types';

import { Button as StyledButton, Link } from './Button.styles';

/**
 * Button
 *
 * This component allows to use `href` and `onClick` props on the same component.
 * It is useful, since `Action` component could have a link to some resources.
 *
 * This component exists because `window.open` call has
 * a vulnerability as a link without `ref="noopener noreferer"`
 * and very few browsers support `noopener` feature for `window.open` call.
 *
 * The `a` node renders if `href` prop was passed.
 * The `button` will be rendered if `onClick` or `disabled` props were passed.
 *
 * @param {*} {
 *     className, children, onClick, href, disabled,
 * }
 * @returns
 */
const Button = ({ className, children, onClick, href, disabled, target }) => {
    if (disabled || !href) {
        return (
            <StyledButton className={className} disabled={disabled} onClick={onClick}>
                {children}
            </StyledButton>
        );
    }

    return (
        <Link className={className} onClick={onClick} href={href} target={target}>
            {children}
        </Link>
    );
};

Button.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
    href: PropTypes.string,
    target: PropTypes.string,
    disabled: PropTypes.bool,
};

Button.defaultProps = {
    className: '',
    children: null,
    onClick: undefined,
    href: undefined,
    disabled: false,
    target: undefined,
};

export default Button;
